<template>
  <div class="dj-layout">
    <dj-header>
    <!--
      <ul class="d-flex flex-center l-s-n menu-list">
        <li :class="['nav-item', $route.path === '/' && 'active']">
          <router-link to="/">首页</router-link>
        </li>
        <li :class="['nav-item', $route.path === '/knows' && 'active']">
          <router-link to="/knows">课程介绍</router-link>
        </li>
        <li :class="['nav-item', $route.path === '/intro' && 'active']">
          <router-link to="/intro">公司简介</router-link>
        </li>
      </ul>
    -->
      <template slot="right">
        <span v-if="$store.state.token" @click="$router.push('/console')" style="cursor: pointer;">我的工作台</span>
      </template>
    </dj-header>
    <main class="dj-main">
      <router-view></router-view>
    </main>
    <dj-footer></dj-footer>
    <BackTop></BackTop>
  </div>
</template>

<script>
import djHeader from './header'
import djFooter from './footer'
export default {
  name: 'djLayout',
  components: { djHeader, djFooter }
}
</script>
